module.exports = __webpack_public_path__ + "static/media/settings-icon.122ff931.svg";